<div class="full-screen-container" data-cy="auth-login-page">
  <div style="font-size: 10px; position: absolute; bottom: 0; right: 0; color: var(--tdo-primary); margin-right: 4px;" data-cy="auth-login-page-version">
    {{appName}} v{{appVersion}}.
  </div>
  <div class="main-flex-container" data-cy="auth-login-page-container">
  <form (keydown.enter)="$event.preventDefault()" data-cy="auth-login-page-form">
    <div class="card-container" data-cy="auth-login-page-card-container">
      <mat-card appearance="outlined" class="login-card"  *ngIf="loginMode && !passwordResetTokenAvailable" data-cy="auth-login-page-login-card">
        <div mat-card-image class="login-card-header" data-cy="auth-login-page-card-header">
          <div class="login-card-header-text" data-cy="auth-login-page-header-text">Login</div>
        </div>

        <div class="login-card-content" data-cy="auth-login-page-card-content">
          <div class="inline-form" data-cy="auth-login-page-location-form">
            <mat-label class="form-label" data-cy="auth-login-page-location-label">Location</mat-label>
            <mat-form-field class="w-100" data-cy="auth-login-page-location-field">
              <mat-select (ngModelChange)="locationSelected($event)" data-cy="auth-login-page-location-select" name="location"
                          [(ngModel)]="selectedLocation">
                <mat-option *ngFor="let location of locations" [value]="location.LOCID"  data-cy="login-location-option">
                  {{location.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="inline-form" data-cy="auth-login-page-username-form">
            <mat-label class="form-label" data-cy="auth-login-page-username-label">Username</mat-label>
            <mat-form-field class="w-100" data-cy="auth-login-page-username-field">
              <input matInput type="text" name="username" autocomplete="username" data-cy="auth-login-page-username-input"
                     maxlength="25" id="username" [(ngModel)]="userName" value="{{userName}}"
                     (keyup.enter)="loginUser()"
                     required="true" />
            </mat-form-field>
          </div>

          <div class="inline-form" data-cy="auth-login-page-password-form">
            <mat-label class="form-label" data-cy="auth-login-page-password-label">Password</mat-label>
            <mat-form-field class="w-100" data-cy="auth-login-page-password-field">
              <input matInput data-cy="auth-login-page-password-input"
                     [type]="fieldTextType ? 'text' : 'password'"
                     name="password"
                     autocomplete="current-password"
                     maxlength="25"
                     id="pass"
                     (keyup.enter)="loginUser()"
                     [(ngModel)]="password"
                     value="{{password}}"
                     required />
                     <mat-icon matSuffix (mousedown)="showPasswords()" (mouseleave)="hidePasswords()" (mouseup)="hidePasswords()" style="padding: 0px;" data-cy="auth-login-page-password-toggle">{{fieldTextType ? 'visibility' : 'visibility_off'}}</mat-icon>
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="invalidCredentials" data-cy="auth-login-page-error-message" ngClass="loginError">Please provide valid credentials.</div>

        <mat-card-footer class="login-card-footer" data-cy="auth-login-page-card-footer">
          <button class="forget-pw-text" href="#" (click)="forgotPasswordClicked()" data-cy="auth-login-page-forgot-password-btn">Reset password</button>

          <button mat-button class="login-card-btn" (click)="loginUser()" type="submit" color="primary" [disabled]="isLoading || loadingLocations || !selectedLocation" data-cy="auth-login-page-login-btn">
            <span *ngIf="!isLoading" data-cy="auth-login-page-login-text">Login</span>
            <mat-spinner class="login-spinner" *ngIf="isLoading" [diameter]="20" data-cy="auth-login-page-spinner"></mat-spinner>
          </button>

        </mat-card-footer>
      </mat-card>

      <mat-card appearance="outlined" class="login-card"  *ngIf="!loginMode && !passwordResetTokenAvailable" data-cy="auth-login-page-reset-card">
        <div mat-card-image class="login-card-header" data-cy="auth-login-page-reset-header">
          <div class="login-card-header-text" data-cy="auth-login-page-reset-header-text">Password Reset</div>
        </div>

        <div class="login-card-content" data-cy="auth-login-page-reset-content">

          <div class="inline-form reset-password-form" data-cy="auth-login-page-reset-username-form">
            <mat-label class="form-label" data-cy="auth-login-page-reset-username-label">Username</mat-label>
            <mat-form-field class="w-100" data-cy="auth-login-page-reset-username-field">
              <input matInput type="text" name="username" autocomplete="username" data-cy="auth-login-page-reset-username-input"
                     maxlength="25" id="username" [(ngModel)]="userName" value="{{userName}}"
                     (keyup.enter)="resetPassword()"
                     required />
            </mat-form-field>
          </div>
          <div class="inline-form reset-password-form" data-cy="auth-login-page-reset-email-form">
            <mat-label class="form-label" data-cy="auth-login-page-reset-email-label">Email</mat-label>
            <mat-form-field class="w-100" data-cy="auth-login-page-reset-email-field">
              <input matInput type="text" name="useremail" autocomplete="email" data-cy="auth-login-page-reset-email-input"
                     Originength="100" id="useremail" [(ngModel)]="userEmail" value="{{userEmail}}"
                     (keyup.enter)="resetPassword()"
                     required />
            </mat-form-field>
          </div>
          <br/>
          <br/>
          <div *ngIf="showChangeMessage" data-cy="auth-login-page-reset-message" ngClass="loginError">{{requestResetPasswordMessage}}</div>
        </div>

        <mat-card-footer class="login-card-footer" data-cy="auth-login-page-reset-footer">
          <button class="forget-pw-text" href="#" (click)="showLogin()" data-cy="auth-login-page-reset-cancel-btn">Cancel</button>

          <button mat-button class="login-card-btn reset-card-btn" (click)="requestResetPassword()" type="submit" color="primary"
          [disabled]="isLoading || userName =='' ||  userEmail == '' || showChangeMessage" data-cy="auth-login-page-reset-request-btn">
            <span *ngIf="!isLoading" data-cy="auth-login-page-reset-request-text">Request Password Change</span>
            <mat-spinner class="login-spinner" *ngIf="isLoading" [diameter]="20" data-cy="auth-login-page-reset-spinner"></mat-spinner>
          </button>

        </mat-card-footer>
      </mat-card>

      <mat-card appearance="outlined" class="login-card"  *ngIf="passwordResetTokenAvailable && !passwordResetConfirmation" data-cy="auth-login-page-change-password-card">
        <div mat-card-image class="login-card-header" data-cy="auth-login-page-change-password-header">
          <div class="login-card-header-text" data-cy="auth-login-page-change-password-header-text">Password Reset</div>
        </div>

        <div class="login-card-content" data-cy="auth-login-page-change-password-content">
          <div class="inline-form reset-password-form" data-cy="auth-login-page-new-password-form">
            <mat-label class="form-label reset-password-label" data-cy="auth-login-page-new-password-label">New Password</mat-label>
            <mat-form-field class="w-100" data-cy="auth-login-page-new-password-field">
              <input matInput data-cy="auth-login-page-new-password-input"
                     [type]="fieldTextType ? 'text' : 'password'"
                     name="passwordChange"
                     autocomplete="new-password"
                     maxlength="25"
                     id="passwordChange"
                     [(ngModel)]="passwordChange"
                     value="{{passwordChange}}"
                     (keyup.enter)="resetPassword()"
                     required />
                     <mat-icon matSuffix (mousedown)="showPasswords()" (mouseleave)="hidePasswords()" (mouseup)="hidePasswords()" style="padding: 0px;" data-cy="auth-login-page-new-password-toggle">{{fieldTextType ? 'visibility' : 'visibility_off'}}</mat-icon>
            </mat-form-field>
          </div>
          <div class="inline-form reset-password-form" data-cy="auth-login-page-confirm-password-form">
            <mat-label class="form-label reset-password-label" data-cy="auth-login-page-confirm-password-label">Confirm New Password</mat-label>
            <mat-form-field class="w-100" data-cy="auth-login-page-confirm-password-field">
              <input matInput data-cy="auth-login-page-confirm-password-input"
                     [type]="fieldTextType ? 'text' : 'password'"
                     name="passwordConfirmation"
                     maxlength="25"
                     id="passwordConfirmation"
                     [(ngModel)]="passwordConfirmation"
                     value="{{passwordConfirmation}}"
                     (keyup.enter)="requestResetPassword()"
                     autocomplete="new-password"
                     required />
            </mat-form-field>
          </div>
          <div data-cy="auth-login-page-password-message" ngClass="loginError" [innerHTML]="passwordChangeMessage"></div>
          <div *ngIf="passwordConfirmation != passwordChange" data-cy="auth-login-page-password-mismatch" ngClass="loginError">Passwords don't match.</div>
        </div>


        <mat-card-footer class="login-card-footer" data-cy="auth-login-page-change-password-footer">
          <button class="forget-pw-text" href="#" (click)="showLogin()" data-cy="auth-login-page-change-password-cancel-btn">Cancel</button>

          <button mat-button class="login-card-btn reset-card-btn" (click)="resetPassword()" type="submit" color="primary"
            [disabled]="isLoading || passwordChange == '' || passwordConfirmation == '' || passwordConfirmation != passwordChange" data-cy="auth-login-page-change-password-btn">
            <span *ngIf="!isLoading" data-cy="auth-login-page-change-password-text">Change Password</span>
            <mat-spinner class="login-spinner" *ngIf="isLoading" [diameter]="20" data-cy="auth-login-page-change-password-spinner"></mat-spinner>
          </button>

        </mat-card-footer>
      </mat-card>

      <mat-card appearance="outlined" class="login-card"  *ngIf="passwordResetConfirmation" data-cy="auth-login-page-confirmation-card">
        <div mat-card-image class="login-card-header" data-cy="auth-login-page-confirmation-header">
          <div class="login-card-header-text" data-cy="auth-login-page-confirmation-header-text">Password Reset</div>
        </div>

        <div class="login-card-content" data-cy="auth-login-page-confirmation-content">

          <div class="inline-form reset-password-form" data-cy="auth-login-page-confirmation-form">
            <div data-cy="auth-login-page-confirmation-message" ngClass="loginError">Password has been changed. You can now login to the application using your new password.</div>
          </div>
        </div>

        <mat-card-footer class="login-card-footer" style="justify-content: center; padding:0" data-cy="auth-login-page-confirmation-footer">
          <button mat-button class="login-card-btn reset-card-btn" (click)="showLogin()" type="submit" color="primary" data-cy="auth-login-page-confirmation-login-btn">
            <span data-cy="auth-login-page-confirmation-login-text">Login</span>
          </button>

        </mat-card-footer>
      </mat-card>

      <div class="links-search-container" data-cy="auth-login-page-links-container">
        <button mat-button class="links" (click)="tdoReferrerClicked()" data-cy="auth-login-page-referrer-link">
          <mat-icon class="material-symbols-outlined link-icons" data-cy="auth-login-page-referrer-icon">stethoscope</mat-icon>Referring Doctors
        </button>
        <button mat-button class="links" (click)="tdoPatientClicked()" data-cy="auth-login-page-patient-link">
          <mat-icon class="material-symbols-outlined link-icons" data-cy="auth-login-page-patient-icon">people</mat-icon>Patient Portal
        </button>
      </div>
    </div>
  </form>
  </div>
</div>
